<script>
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
import { ref } from "vue";
import moment from "moment";

/**
 * Confirm-mail component
 */
export default {
  page: {
    title: "Confirm Kehadiran Peserta",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      id_pembelajaran: this.$route.params.idPembelajaran,
      id_peserta: this.$route.params.idPeserta,

      kode: null,
      judul: null,
      dasar_pelaksanaan: null,
      strategi: null,
      durasi_he: null,
      durasi_jp: null,
      tanggal_mulai: null,
      tanggal_selesai: null,
      learning_type: null,
      angkatan: null,
      pratikum: null,
      pic_pnt: null,
      pic_pte: null,

      nama_peserta: null,
      status_peserta: null,
      status_btn_confirm: true,
      tgl_hari_ini: moment(ref(new Date())).format("YYYY-MM-DD"),

      configuration: [],
    };
  },
  components: {},
  mounted() {
    let self = this;
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    var config_login = {
      method: "get",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/konfig-login",
      headers: {
        Accept: "application/json",
      },
    };
    axios(config_login)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          self.configuration = response_data_fix.referensi;
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    // get data pembelajaran
    var config = {
      method: "get",
      url:
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "referensi/pembelajaran-data-peserta",
      params: {
        id_pembelajaran: self.id_pembelajaran,
        id_peserta: self.id_peserta,
      },
      headers: {
        Accept: "application/json",
      },
    };
    axios(config)
      .then(function (response) {
        var response_data = response.data;
        if (response_data.meta.code == 200) {
          var data_pembelajaran = response_data.data.data_pembelajaran;
          console.log(data_pembelajaran);
          self.kode = data_pembelajaran.pbl_kode;
          self.judul = data_pembelajaran.pbl_judul;
          self.dasar_pelaksanaan = data_pembelajaran.pbl_dasar_pelaksanaan;
          self.strategi = data_pembelajaran.pbl_strategi;
          self.durasi_he = data_pembelajaran.pbl_durasi_he;
          self.durasi_jp = data_pembelajaran.pbl_durasi_jp;
          self.tanggal_mulai = data_pembelajaran.pbl_tgl_mulai;
          self.tanggal_selesai = data_pembelajaran.pbl_tgl_selesai;
          self.learning_type = data_pembelajaran.pbl_lt_name;
          self.angkatan = data_pembelajaran.pbl_angkatan;
          self.pratikum = data_pembelajaran.pbl_pratikum;
          self.status_submit = data_pembelajaran.status_perencanaan;

          if (data_pembelajaran.pic_pnt != null) {
            self.pic_pnt =
              data_pembelajaran.pic_pnt.mp_nama +
              " - " +
              data_pembelajaran.pic_pnt.user.username +
              " - " +
              data_pembelajaran.pic_pnt.user.name;
          }

          if (data_pembelajaran.pic_pte != null) {
            self.pic_pte =
              data_pembelajaran.pic_pte.mp_nama +
              " - " +
              data_pembelajaran.pic_pte.user.username +
              " - " +
              data_pembelajaran.pic_pte.user.name;
          }

          var data_peserta = response_data.data.data_peserta;
          self.nama_peserta = data_peserta.user.name;
          self.status_peserta = data_peserta.status_peserta;

          if (self.tgl_hari_ini >= data_pembelajaran.pbl_tgl_mulai) {
            if (self.tgl_hari_ini > data_pembelajaran.pbl_tgl_selesai) {
              self.status_btn_confirm = false;
            } else {
              self.status_btn_confirm = true;
            }
          } else {
            if (self.tgl_hari_ini < data_pembelajaran.pbl_tgl_mulai) {
              self.status_btn_confirm = true;
            } else {
              self.status_btn_confirm = false;
            }
          }

          Swal.close();
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data.meta.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        Swal.close();
      });
  },
  methods: {
    changeStatusData(status) {
      let self = this;

      let text_alert = "";
      if (status == "BERSEDIA") {
        text_alert =
          "Apakah anda yakin bersedia mengikuti agenda pembelajaran tersebut?";
      } else if (status == "TIDAK BERSEDIA") {
        text_alert =
          "Apakah anda yakin tidak bersedia mengikuti agenda pembelajaran tersebut?";
      }

      Swal.fire({
        title: "Perhatian",
        text: text_alert,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          self.loadingTable = true;
          Swal.fire({
            title: '<i class="fa fa-refresh fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
          });

          var config = {
            method: "get",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "referensi/confirm-kehadiran-peserta",
            params: {
              id_pembelajaran: self.id_pembelajaran,
              id_peserta: self.id_peserta,
              status: status,
            },
            headers: {
              Accept: "application/json",
            },
          };
          axios(config).then((response) => {
            var response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Terima kasih telah melakukan konfirmasi.",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  window.location.reload();
                }
              });
            }
          });
        } else {
          Swal.close();
        }
      });
    },
  },
};
</script>

<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-4 text-muted">
            <router-link to="/" class="d-block auth-logo">
              <img
                :src="configuration.LOGO_FULL_DARK"
                v-bind:alt="configuration.APPLICATION_FULL_NAME"
                height="100"
                class="auth-logo-dark mx-auto"
              />
              <img
                :src="configuration.LOGO_FULL_LIGHT"
                v-bind:alt="configuration.APPLICATION_FULL_NAME"
                height="100"
                class="auth-logo-light mx-auto"
              />
            </router-link>
            <h4 class="mt-3">{{ configuration.APPLICATION_FULL_NAME }}</h4>
            <h5>Undangan Peserta</h5>
          </div>
        </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <div v-if="status_peserta == 'MENUNGGU KONFIRMASI'">
              <div class="card-body">
                <div class="p-0">
                  <div class="text-center">
                    <div class="avatar-md mx-auto">
                      <div class="avatar-title rounded-circle bg-light">
                        <i class="bx bx-mail-send h1 mb-0 text-primary"></i>
                      </div>
                    </div>
                    <div class="p-2 mt-2">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            Halo, <b>{{ nama_peserta }}</b> anda diundang
                            sebagai dalam agenda pembelajaran dengan detail
                            sebagai berikut:
                          </p>
                        </div>
                        <div class="col-12 mt-2 mb-2">
                          <div class="row">
                            <div class="col-6">
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Kode Pembelajaran</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ kode }}</p>
                                <hr />
                              </div>

                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Judul Pembelajaran</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ judul }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark">Strategi</span>
                                </h5>
                                <p class="text-muted mb-0">{{ strategi }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Durasi Hari Efektif (HE)</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ durasi_he }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Durasi Jam Pembelajaran (JP)</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ durasi_jp }}</p>
                                <hr />
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="row">
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Dasar Pelaksanaan</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ dasar_pelaksanaan }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Tipe Pembelajaran</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ learning_type }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark">Angkatan</span>
                                  </h5>
                                  <p class="text-muted mb-0">{{ angkatan }}</p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark">Tanggal Mulai</span>
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ tanggal_mulai }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Tanggal Selesai</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ tanggal_selesai }}
                                  </p>
                                  <hr />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <p>
                            Mohon lakukan konfirmasi kehadiran pada pembelajaran
                            tersebut dengan klik tombol berikut
                          </p>
                        </div>
                        <div class="col-6 text-end">
                          <div class="mt-2">
                            <button
                              type="button"
                              class="btn btn-success"
                              @click="changeStatusData('BERSEDIA')"
                            >
                              <i class="fas fa-check"></i> Bersedia
                            </button>
                          </div>
                        </div>
                        <div class="col-6 text-start">
                          <div class="mt-2">
                            <button
                              type="button"
                              class="btn btn-danger"
                              @click="changeStatusData('TIDAK BERSEDIA')"
                            >
                              <i class="fa fa-times"></i> Tidak Bersedia
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="status_peserta == 'BERSEDIA'">
              <div class="card-body">
                <div class="p-0">
                  <div class="text-center">
                    <div class="avatar-md mx-auto">
                      <div class="avatar-title rounded-circle bg-light">
                        <i class="fas fa-check h1 mb-0 text-success"></i>
                      </div>
                    </div>
                    <div class="p-2 mt-2">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            Halo, <b>{{ nama_peserta }}</b
                            >, Terima kasih atas konfirmasi jika anda
                            <b>bersedia</b> mengikuti agenda pembelajaran dengan
                            detail sebagai berikut :
                          </p>
                        </div>
                        <div class="col-12 mt-2 mb-2">
                          <div class="row">
                            <div class="col-6">
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Kode Pembelajaran</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ kode }}</p>
                                <hr />
                              </div>

                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Judul Pembelajaran</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ judul }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark">Strategi</span>
                                </h5>
                                <p class="text-muted mb-0">{{ strategi }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Durasi Hari Efektif (HE)</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ durasi_he }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Durasi Jam Pembelajaran (JP)</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ durasi_jp }}</p>
                                <hr />
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="row">
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Dasar Pelaksanaan</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ dasar_pelaksanaan }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Tipe Pembelajaran</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ learning_type }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark">Angkatan</span>
                                  </h5>
                                  <p class="text-muted mb-0">{{ angkatan }}</p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark">Tanggal Mulai</span>
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ tanggal_mulai }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Tanggal Selesai</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ tanggal_selesai }}
                                  </p>
                                  <hr />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 text-end">
                          <div class="mt-2">
                            <button
                              v-if="status_btn_confirm == true"
                              type="button"
                              class="btn btn-success"
                              @click="changeStatusData('BERSEDIA')"
                            >
                              <i class="fas fa-check"></i> Bersedia
                            </button>
                          </div>
                        </div>
                        <div class="col-6 text-start">
                          <div class="mt-2">
                            <button
                              v-if="status_btn_confirm == true"
                              type="button"
                              class="btn btn-danger"
                              @click="changeStatusData('TIDAK BERSEDIA')"
                            >
                              <i class="fa fa-times"></i> Tidak Bersedia
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="status_peserta == 'TIDAK BERSEDIA'">
              <div class="card-body">
                <div class="p-0">
                  <div class="text-center">
                    <div class="avatar-md mx-auto">
                      <div class="avatar-title rounded-circle bg-light">
                        <i class="fas fa-times h1 mb-0 text-danger"></i>
                      </div>
                    </div>
                    <div class="p-2 mt-2">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            Halo, <b>{{ nama_peserta }}</b
                            >, Terima kasih atas konfirmasi jika anda
                            <b>tidak bersedia</b> mengikuti agenda pembelajaran
                            dengan detail sebagai berikut :
                          </p>
                        </div>
                        <div class="col-12 mt-2 mb-2">
                          <div class="row">
                            <div class="col-6">
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Kode Pembelajaran</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ kode }}</p>
                                <hr />
                              </div>

                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Judul Pembelajaran</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ judul }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark">Strategi</span>
                                </h5>
                                <p class="text-muted mb-0">{{ strategi }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Durasi Hari Efektif (HE)</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ durasi_he }}</p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Durasi Jam Pembelajaran (JP)</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">{{ durasi_jp }}</p>
                                <hr />
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="row">
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Dasar Pelaksanaan</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ dasar_pelaksanaan }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Tipe Pembelajaran</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ learning_type }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark">Angkatan</span>
                                  </h5>
                                  <p class="text-muted mb-0">{{ angkatan }}</p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark">Tanggal Mulai</span>
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ tanggal_mulai }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Tanggal Selesai</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ tanggal_selesai }}
                                  </p>
                                  <hr />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 text-end">
                          <div class="mt-2">
                            <button
                              v-if="status_btn_confirm == true"
                              type="button"
                              class="btn btn-success"
                              @click="changeStatusData('BERSEDIA')"
                            >
                              <i class="fas fa-check"></i> Bersedia
                            </button>
                          </div>
                        </div>
                        <div class="col-6 text-start">
                          <div class="mt-2">
                            <button
                              v-if="status_btn_confirm == true"
                              type="button"
                              class="btn btn-danger"
                              @click="changeStatusData('TIDAK BERSEDIA')"
                            >
                              <i class="fa fa-times"></i> Tidak Bersedia
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 text-center">
            <p>
              ©
              {{ new Date().getFullYear() }}
              {{ configuration.COPYRIGHT_COPORATION }}.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
